import { ADD_HSN_SUB, DELETE_HSN_SUB, GET_HSN_SUB, UPDATE_HSN_SUB } from "../types";
  
  const initialState = { list: [], single: null };
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_HSN_SUB:
        return { ...state, list: payload };
  
      case UPDATE_HSN_SUB:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_HSN_SUB:
        return {
          ...state,
          list: [payload, ...state.list],
        };
  
      case DELETE_HSN_SUB:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
        };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  